// extracted by mini-css-extract-plugin
module.exports = {"selectboxFilterWrapper":"UnitFilter_selectboxFilterWrapper__j8_Qw"};